export const DAY_ORDER_SHORT = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const
export const DAY_ORDER_FULL = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const

export const SHORT_TO_FULL_DAY_MAP = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday'
} as const

export const FULL_TO_SHORT_DAY_MAP = {
  Monday: 'mon',
  Tuesday: 'tue',
  Wednesday: 'wed',
  Thursday: 'thu',
  Friday: 'fri',
  Saturday: 'sat',
  Sunday: 'sun'
} as const

export type DayShort = typeof DAY_ORDER_SHORT[number]
export type DayFull = typeof DAY_ORDER_FULL[number]

/**
 * Gets the next day in the week
 */
export function getNextDay(day: DayShort): DayShort {
  const currentIndex = DAY_ORDER_SHORT.indexOf(day)
  const nextIndex = (currentIndex + 1) % DAY_ORDER_SHORT.length
  return DAY_ORDER_SHORT[nextIndex]
}

/**
 * Gets the previous day in the week
 */
export function getPreviousDay(day: DayShort): DayShort {
  const currentIndex = DAY_ORDER_SHORT.indexOf(day)
  const prevIndex = currentIndex === 0 ? DAY_ORDER_SHORT.length - 1 : currentIndex - 1
  return DAY_ORDER_SHORT[prevIndex]
}

/**
 * Gets the index of a day in the week (0-based, Monday = 0)
 */
export function getDayIndex(day: DayShort): number {
  return DAY_ORDER_SHORT.indexOf(day)
}

/**
 * Converts short day format to full day format
 */
export function shortToFullDay(day: DayShort): DayFull {
  return SHORT_TO_FULL_DAY_MAP[day]
}

/**
 * Converts full day format to short day format
 */
export function fullToShortDay(day: DayFull): DayShort {
  return FULL_TO_SHORT_DAY_MAP[day]
}

/**
 * Type-safe version of getDayIndex that accepts any string
 */
export function safeDayIndex(day: string): number {
  return DAY_ORDER_SHORT.indexOf(day as DayShort)
}

/**
 * Type-safe version of shortToFullDay that accepts any string
 */
export function safeShortToFull(day: string): string {
  const dayShort = day as DayShort
  return SHORT_TO_FULL_DAY_MAP[dayShort] || day
}

/**
 * Type-safe version of fullToShortDay that accepts any string
 */
export function safeFullToShort(day: string): string {
  const dayFull = day as DayFull
  return FULL_TO_SHORT_DAY_MAP[dayFull] || day
}